/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Acted Core API
 * Core backend API.
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `new` - New
 * * `done` - Done
 */
export type ArchiveDocumentListItemState = typeof ArchiveDocumentListItemState[keyof typeof ArchiveDocumentListItemState];


export const ArchiveDocumentListItemState = {
  NEW: 'new',
  DONE: 'done',
} as const;
